<template>
  <div id="gradeForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="grade.name"
        label="Grade Name"
        :rules="[rules.required]"
        :required="true"
      />

      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack"> Back </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>
    
<script>
import { getGrade } from "@/services/grade";
import { rules } from "@/store/util/rules.js";

import { mapActions } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      grade: {
        relations: {},
        name: "",
      },
      rules
    };
  },
  created() {
    this.setInstance();
  },
  methods: {
    ...mapActions("grade", ["createGrade", "updateGrade"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      
      if (this.id) {
        let grade = this.grade;
        delete grade.relations;

        this.updateGrade(grade)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Grade was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating Grade, please try again later"
            );
          });
      } else {
        let grade = this.grade;
        delete grade.relations;

        this.createGrade(grade)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Grade was created successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error creating Grade, please try again later"
            );
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.grade.id = this.id;
        getGrade(this.id).then((response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.grade, property)
            ) {
              this.grade[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
  },
  components: {},
};
</script>
